module.exports = __webpack_public_path__ + "static/img/e3352dc62c1e44a3feb825e319e2f27b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T21.jpg
// module id = Aj18
// module chunks = 1